/**
 * Оболочка загрузки живёт в `index.html`, вне `#root`.
 *
 * Пока бандл не исполнен, в корне пусто, и человек видит тёмный лист — это
 * выглядит зависанием, хотя страница ещё собирается. Оболочка закрывает только
 * этот зазор на первом заходе ленты. Живую ленту, студию и окно вилки ею
 * не накрываем: 13.08 так закрывали чёрный кадр по возврату с конторы и
 * получили пять секунд «собираем вилки» на уже открытой карточке.
 *
 * Склейку кадров, сетку порядка и `content-visibility` это не трогает:
 * оболочка — слой поверх, не другая частота ленты.
 */

export function bootAway(): void {
  document.documentElement.classList.add('nx-waking');
}

export function bootReady(): void {
  document.documentElement.classList.add('nx-ready');
  document.documentElement.classList.remove('nx-waking');
}
